/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkAlcoBottleWineIcon16Solid = forwardRef('FoodDrinkAlcoBottleWineIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.5.75A.75.75 0 0 1 7.25 0h1.5a.75.75 0 0 1 .75.75v3.395c1.446.43 2.5 1.77 2.5 3.355v6.75A1.75 1.75 0 0 1 10.25 16h-4.5A1.75 1.75 0 0 1 4 14.25V7.5a3.502 3.502 0 0 1 2.5-3.355V.75ZM5.25 8a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h5.5a.25.25 0 0 0 .25-.25v-3.5a.25.25 0 0 0-.25-.25h-5.5Z" })));
});
